<template>
  <form
    name="audioStickerRecorder"
    @submit.prevent="submit"
  >
    <div class="text-center">
      <h2 v-t="{ path: 'audioRecorder.header', args: [participant ? participant.firstname : ''] }"/>
      <p
        v-t="{ path: 'audioRecorder.text', args: [participant ? participant.firstname : ''] }"
        class="mb-0"
      />
    </div>

    <AudioRecorder
      v-model="recording"
      :max="5"
      :class="[$style.recorder, 'd-flex flex-column-reverse text-condensed font-weight-bold']"
      :play-label="$t('audioRecorder.play')"
      :record-label="$t('audioRecorder.record')"
      :stop-label="$t('audioRecorder.stop')"
      button-class="text-condensed font-weight-bold"
    />

    <div
      class="text-center text-muted pt-2"
      :class="$style.help"
      v-html="$t('audioRecorder.help', [helpLinkAttributes])"
    />

    <div
      v-t="'audioRecorder.disclaimer'"
      class="text-center my-3 py-3 px-4 bg-body"
    />

    <div class="position-relative text-center">
      <transition name="fade">
        <div
          v-if="error"
          role="alert"
          class="alert alert-danger mt-3 position-absolute w-100 bottom-0"
        >{{ error }}</div>
      </transition>
      <transition name="fade">
        <div
          v-if="success"
          v-t="{ path: 'audioStickerOverlay.success.message', args: [participant ? participant.firstname : '']}"
          role="alert"
          class="alert alert-gray-800 white-space-pre mt-3 w-100 position-absolute bottom-0"
        />
      </transition>
    </div>

    <div class="text-center">
      <button
        class="btn btn-secondary btn-block mt-3"
        type="submit"
        :disabled="loading || !recording"
      >
        {{ $t('audioRecorder.submit') }}
      </button>
    </div>
  </form>
</template>

<script>
import '@worldrun/audio-sticker/dist/audio-sticker.css'
import { AudioRecorder } from '@worldrun/audio-sticker'
import { putTeamAudioStickers } from '@/api'

export default {
  name: 'AudioStickerRecorder',
  components: {
    AudioRecorder
  },
  props: {
    participant: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      recording: null,
      success: false,
      loading: false,
      error: null
    }
  },
  computed: {
    helpLinkAttributes() {
      return 'href="/help" target="_blank" class="text-muted"'
    }
  },
  methods: {
    async submit() {
      this.error = null
      this.loading = true
      try {
        await putTeamAudioStickers(this.participant.userId, this.recording)
        this.success = true
        setTimeout(() => {
          this.success = false
        }, 2e3)
      } catch (e) {
        this.error = e.message
        setTimeout(() => {
          this.error = ''
        }, 2e3)
      }
      this.recording = null
      this.loading = false
    }
  }
}
</script>

<style lang="scss" module>
.recorder {
  --audio-recorder-primary: #{$red};
  --audio-recorder-secondary: #{$blue};

  gap: .75rem;
}

.help {
  font-size: 75%;
  a {
    text-decoration: underline;
  }
}
</style>
